import type { LucideIcon } from "lucide-react";
import {
  Cpu,
  GraduationCap,
  HeartPulse,
  Landmark,
  Megaphone,
  MoreHorizontal,
  Paintbrush,
  ShoppingCart,
} from "lucide-react";

/** TENANT_SETUP_INDUSTRY_IDS lists the industries in the order they show. */
export const TENANT_SETUP_INDUSTRY_IDS = [
  "technology",
  "handcraft",
  "marketing",
  "health",
  "ecommerce",
  "education",
  "finance",
  "other",
] as const;

export type TenantSetupIndustryId = (typeof TENANT_SETUP_INDUSTRY_IDS)[number];

export const TENANT_SETUP_INDUSTRY_ICON_BY_ID: Record<
  TenantSetupIndustryId,
  LucideIcon
> = {
  ecommerce: ShoppingCart,
  education: GraduationCap,
  finance: Landmark,
  handcraft: Paintbrush,
  health: HeartPulse,
  marketing: Megaphone,
  other: MoreHorizontal,
  technology: Cpu,
};

export const TENANT_SETUP_INDUSTRY_LABEL_KEY_BY_ID: Record<
  TenantSetupIndustryId,
  string
> = {
  ecommerce: "company_setup_industry_ecommerce",
  education: "company_setup_industry_education",
  finance: "company_setup_industry_finance",
  handcraft: "company_setup_industry_handcraft",
  health: "company_setup_industry_health",
  marketing: "company_setup_industry_marketing",
  other: "company_setup_industry_other",
  technology: "company_setup_industry_technology",
};
